// extracted by mini-css-extract-plugin
module.exports = {"root":"Boxes_root_3QuUl","row":"Boxes_row_19IdA","margin":"Boxes_margin_1TzYz","pack":"Boxes_pack_kfRs1","flickity":"Boxes_flickity_3KgxH"};